import { useEffect } from 'react'

export default ({ containerRef, scrollerRef, disabled }) => {
    useEffect(() => {
        const handleWheel = e => {
            if (!scrollerRef.current) {
                return
            }

            // 是否在滚动区域
            const isInSCroller = scrollerRef.current.contains(e.target)
            if (isInSCroller) {
                // console.info('isInSCroller')
                return
            }

            // 是否在浮层内
            const isInPopContent = checkIsInPopContent(e.target)
            if (!isInPopContent) {
                // console.info('isInPopContent')
                return
            }

            let position = { x: e.x, y: e.y }

            const arrowEl = e.target.closest('.ant-tooltip')?.querySelector?.('.ant-tooltip-arrow')

            if (arrowEl) {
                // 如果是下拉框，获取下拉框箭头的坐标
                const rect = arrowEl.getBoundingClientRect()

                position = { x: rect.left + rect.width / 2, y: rect.top + rect.height / 2 }

                // console.info('arrowEl:', position)
            }

            // 是否是相同坐标点的元素
            const elements = getElementsAtPosition(position.x, position.y)
            const isSamePostionEls = elements.some(el => containerRef.current.contains(el))
            if (!isSamePostionEls) {
                // console.info('isSamePostionEls')
                return
            }

            // 是否可滚动
            const scrollableEl = checkIsScrollable(e.target)
            if (scrollableEl) {
                // console.info('isScrollable', {
                //     scrollTop: scrollableEl.scrollTop,
                //     deltaY: e.deltaY,
                //     maxTop: scrollableEl.scrollHeight - scrollableEl.clientHeight
                // })
                if (
                    scrollableEl.scrollTop + e.deltaY < 0 ||
                    scrollableEl.scrollTop + e.deltaY > scrollableEl.scrollHeight - scrollableEl.clientHeight
                ) {
                    e.preventDefault()
                    scrollableEl.scrollTop += e.deltaY
                }

                return
            }

            e.preventDefault()
            scrollerRef.current.scrollTop += e.deltaY
        }

        if (disabled) {
            window.removeEventListener('wheel', handleWheel)
            return
        }

        window.addEventListener('wheel', handleWheel, { passive: false })

        return () => {
            window.removeEventListener('wheel', handleWheel)
        }
    }, [disabled])
}

const getElementsAtPosition = (x, y) => {
    if (typeof document.elementsFromPoint === 'function') {
        const elements = document.elementsFromPoint(x, y)
        return Array.from(elements)
    }

    return []
}

function checkIsScrollable(element) {
    function isScrollable(el) {
        if (el.scrollHeight && el.clientHeight) {
            // console.info('scrollableEl', {
            //     el,
            //     scrollHeight: el.scrollHeight,
            //     clientHeight: el.clientHeight
            // })
            const style = window.getComputedStyle(el)
            const hasOverflow = /auto|scroll|overlay/.test(style.overflow + style.overflowY)

            return hasOverflow && el.scrollHeight > el.clientHeight
        }

        return false
    }

    let current = element
    while (current !== document.body) {
        if (!checkIsInPopContent(current)) {
            return false
        }

        if (isScrollable(current)) {
            return current
        }

        current = current.parentElement
    }

    return false
}

function checkIsInPopContent(element) {
    return ['.ant-tooltip', '.ant-select-dropdown'].some(v => element?.closest(v))
}
